export default [
  {
    type: 'section',
    title: 'Informasi Kategori',
    description: 'Isi informasi kategori untuk ditampilkan di aplikasi.',
  },
  {
    key: 'media_id',
    image: 'image_url',
    label: 'Foto Kategori',
    type: 'image',
    required: true,
  },
  {
    key: 'name',
    label: 'Nama',
    required: true,
    maxLength: 255,
  },
  {
    key: 'slug',
    label: 'Slug',
    required: true,
    maxLength: 255,
    notes: [
      'Gunakan pola huruf-kecil-angka-strip, contoh: fashion-pria.',
    ],
  },
  {
    key: 'parent_id',
    label: 'Parent',
    type: 'select',
    actionSearch: 'categoryV2/searchParents',
    text: 'name',
    initialOptions: true,
    notes: 'Opsional. Kosongkan untuk menjadikan kategori utama.',
  },
  {
    key: 'is_essential',
    label: 'Esensial',
    type: 'radio',
    value: false,
    options: [
      { value: true, text: 'Ya' },
      { value: false, text: 'Tidak' },
    ],
    notes: 'Hanya berlaku untuk sub-kategori. Kategori esensial tampil lebih dulu di kategori gift.',
    visibility: {
      callback: fields => !!(fields.find(f => f.key === 'parent_id') || {}).value,
    },
  },
  {
    key: 'order',
    label: 'Urutan',
    type: 'number',
    min: 0,
    notes: [
      'Angka yang lebih kecil tampil lebih dulu.',
    ],
  },
  {
    key: 'article',
    label: 'Artikel',
    type: 'textarea',
  },
]
